import Header from "../Header";
import Breadcrumb from "../Breadcrumb";
import Question from "../Question/Question";
import Footer from "../Footer";

const FaqPage = () => {

  const pathData = [
    { path: '/', title: 'Home' },
    { path: '/faq', title: 'Faq' }
  ];

  return (
    <>
      <Header logoColor="dark" />
      <Breadcrumb pathData={pathData} />
      <Question />
      <Footer />
    </>
  );
};

export default FaqPage;
